import { render, staticRenderFns } from "./leftMenuItem.vue?vue&type=template&id=33eca0d6&"
import script from "./leftMenuItem.vue?vue&type=script&lang=js&"
export * from "./leftMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./leftMenuItem.vue?vue&type=style&index=0&id=33eca0d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports